'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_WebSockets$Error$() {
}
export { $c_Lpresto_WebSockets$Error$ as $c_Lpresto_WebSockets$Error$ };
$p = $c_Lpresto_WebSockets$Error$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_WebSockets$Error$;
/** @constructor */
function $h_Lpresto_WebSockets$Error$() {
}
export { $h_Lpresto_WebSockets$Error$ as $h_Lpresto_WebSockets$Error$ };
$h_Lpresto_WebSockets$Error$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 67232232;
});
$p.l = (function() {
  return "Error";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "Error";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_WebSockets$Error$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_WebSockets$Error$, "presto.WebSockets$Error$", ({
  Vw: 1,
  d8: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_WebSockets$Error$ as $d_Lpresto_WebSockets$Error$ };
var $n_Lpresto_WebSockets$Error$;
function $m_Lpresto_WebSockets$Error$() {
  if ((!$n_Lpresto_WebSockets$Error$)) {
    $n_Lpresto_WebSockets$Error$ = new $c_Lpresto_WebSockets$Error$();
  }
  return $n_Lpresto_WebSockets$Error$;
}
export { $m_Lpresto_WebSockets$Error$ as $m_Lpresto_WebSockets$Error$ };
//# sourceMappingURL=presto.-Web-Sockets$-Error$.js.map
